import clsx from 'clsx';
import React from 'react';

import { AggregateRatingProps } from './Rating.types';
import { Rating } from './Rating';

export const AggregateRating = React.memo(
  ({
    isBackgroundDark = false,
    reviewsLink,
    testid,
    ...ratingProps
  }: AggregateRatingProps): JSX.Element => {
    return (
      <div
        className={clsx('rating-aggregate', {
          'is-background-dark': isBackgroundDark,
        })}
        data-testid={testid}
      >
        <Rating isNumericVisible={true} {...ratingProps} />
        {reviewsLink && (
          <a className='rating__reviews-link' href={reviewsLink}>
            Read reviews
          </a>
        )}
      </div>
    );
  }
);
AggregateRating.displayName = 'AggregateRating';
